import { getNomeMes } from 'utils/dateFormatter';

const columnsGrid = [
  {
    title: 'Mês',
    dataIndex: 'mes',
    key: 'mes',
  },
  {
    title: 'Abertos',
    dataIndex: 'abertos',
    key: 'abertos',
    align: 'right',
  },
  {
    title: 'Atendidos',
    dataIndex: 'atendidos',
    key: 'atendidos',
    align: 'right',
  },
  {
    title: 'Deferidos',
    dataIndex: 'deferidos',
    key: 'deferidos',
    align: 'right',
  },
  {
    title: 'Indeferidos',
    dataIndex: 'indeferidos',
    key: 'indeferidos',
    align: 'right',
  },
  {
    title: 'Protocolados',
    dataIndex: 'processos',
    key: 'processos',
    align: 'right',
  },
  {
    title: 'Pendente Atendente',
    dataIndex: 'pendenteAtendente',
    key: 'pendenteAtendente',
    align: 'right',
  },
  {
    title: 'Pendente Atendente Setorial',
    dataIndex: 'pendenteAtendenteSetorial',
    key: 'pendenteAtendenteSetorial',
    align: 'right',
  },
];

const columnsGridSetorial = [
  {
    title: 'Mês',
    dataIndex: 'mes',
    key: 'mes',
  },
  {
    title: 'Atendidos',
    dataIndex: 'atendidos',
    key: 'atendidos',
    align: 'right',
  },
  {
    title: 'Deferidos',
    dataIndex: 'deferidos',
    key: 'deferidos',
    align: 'right',
  },
  {
    title: 'Indeferidos',
    dataIndex: 'indeferidos',
    key: 'indeferidos',
    align: 'right',
  },
  {
    title: 'Protocolados',
    dataIndex: 'processos',
    key: 'processos',
    align: 'right',
  },
  {
    title: 'Pendente Atendente Setorial',
    dataIndex: 'pendenteAtendenteSetorial',
    key: 'pendenteAtendenteSetorial',
    align: 'right',
  },
];

const columnsGridPerformance = [
  {
    title: 'Atendente',
    dataIndex: 'nomeAtendente',
    key: 'nomeAtendente',
  },
  {
    title: 'Iniciados',
    dataIndex: 'iniciados',
    key: 'iniciados',
    align: 'right',
  },
  {
    title: 'Pendentes',
    dataIndex: 'pendentes',
    key: 'pendentes',
    align: 'right',
  },
  {
    title: 'Encaminhados',
    dataIndex: 'encaminhado',
    key: 'encaminhado',
    align: 'right',
  },
  {
    title: 'Devolvidos',
    dataIndex: 'devolvido',
    key: 'devolvido',
    align: 'right',
  },
  {
    title: 'Deferidos',
    dataIndex: 'deferidos',
    key: 'deferidos',
    align: 'right',
  },
  {
    title: 'Indeferidos',
    dataIndex: 'indeferidos',
    key: 'indeferidos',
    align: 'right',
  },
  {
    title: 'Protocolados',
    dataIndex: 'processos',
    key: 'processos',
    align: 'right',
  },
  {
    title: 'Atendidos',
    dataIndex: 'atendidos',
    key: 'atendidos',
    align: 'right',
  },
];

const montarLinhaGrid = (meses, ano) => {
  return meses?.map(item => {
    return {
      key: item.mesReferencia,
      mes: getNomeMes(item.mesReferencia, ano),
      abertos: item?.relatorioSolicitacoesResumido['ABERTO'],
      atendidos: item?.relatorioSolicitacoesResumido['SOLICITACAOATENDIDA'],
      deferidos: item?.relatorioSolicitacoesResumido['FIMDEFERIDO'],
      indeferidos: item?.relatorioSolicitacoesResumido['FIMINDEFERIDO'],
      processos: item?.relatorioSolicitacoesResumido['FIMPROCESSO'],
      pendenteAtendente: item?.relatorioSolicitacoesResumido['PENDENTE ATENDENTE'],
      pendenteAtendenteSetorial: item?.relatorioSolicitacoesResumido['PENDENTE ATENDENTE SETORIAL'],
    };
  });
};

const montarLinhaGridPerformance = atendentes => {
  return atendentes?.map(item => {
    return {
      nomeAtendente: item?.nomeAtendente,
      iniciados: item?.iniciados,
      deferidos: item?.deferido,
      indeferidos: item?.indeferido,
      processos: item?.processo,
      pendentes: item?.pendentes,
      encaminhado: item?.encaminhado,
      devolvido: item?.devolvido,
      atendidos: item?.atendido,
    };
  });
};

export { columnsGrid, columnsGridSetorial, columnsGridPerformance, montarLinhaGrid, montarLinhaGridPerformance };
